import {
  bankAccountUI,
  descriptionUI,
  radioSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import {
  paymentInformationTitle,
  EligibilityRegulationNote,
  CheckGuideDetails,
} from '../../components/additionalInformation/PaymentInformation';
import {
  validateRoutingNumber,
  validateBankAccountNumber,
  validateBankName,
} from '../../utils/validations';
import ObfuscateReviewField from '../../components/additionalInformation/ObfuscateReviewField';

const { financialInstitutionName, routingNumber, accountNumber } =
  fullSchema.properties.directDeposit.properties;

const baseUIAll = bankAccountUI();

// Strip out any object-level ui:order/description from the pattern to avoid conflicts
const {
  // eslint-disable-next-line no-unused-vars
  'ui:order': _dropOrder,
  // eslint-disable-next-line no-unused-vars
  'ui:description': _dropDesc,
  ...baseBankAccountUI
} = baseUIAll;

// Customizes the shared bankAccountUI pattern: adds custom error messages and
// inserts check-guide/help-text view fields. Keeps the pattern's keys; the
// submit transformer maps them to the Lighthouse names.
export default {
  uiSchema: {
    // Bank details show once on the confirmation page, via the review page.
    'ui:confirmationField': () => null,
    ...titleUI(paymentInformationTitle),
    ...descriptionUI(EligibilityRegulationNote),
    directDeposit: {
      ...baseBankAccountUI,

      // Explicitly null any lingering order from upstream patterns (VRRAP-style)
      'ui:order': null,
      accountType: {
        ...baseBankAccountUI.accountType,
        'ui:errorMessages': {
          required: 'Select a response',
        },
      },
      'view:checkGuideDetails': {
        'ui:field': 'ViewField',
        'ui:description': CheckGuideDetails,
      },
      routingNumber: {
        ...baseBankAccountUI.routingNumber,
        'ui:title': 'Bank’s 9-digit routing number',
        'ui:validations': [validateRoutingNumber],
        'ui:reviewField': ObfuscateReviewField,
        'ui:errorMessages': {
          pattern: 'Enter a valid 9-digit routing number',
          required: 'Enter a 9-digit routing number',
        },
      },
      accountNumber: {
        ...baseBankAccountUI.accountNumber,
        'ui:reviewField': ObfuscateReviewField,
        'ui:validations': [validateBankAccountNumber],
        'ui:errorMessages': {
          pattern: 'Enter a valid 5-17 digit bank account number',
        },
      },
      bankName: {
        ...baseBankAccountUI.bankName,
        'ui:validations': [validateBankName],
        'ui:errorMessages': {
          required: 'Enter a bank name',
          pattern: 'Enter a bank name',
        },
      },
    },
  },
  schema: {
    type: 'object',
    properties: {
      directDeposit: {
        type: 'object',
        required: ['accountType', 'bankName', 'routingNumber', 'accountNumber'],
        properties: {
          accountType: radioSchema(['checking', 'savings']),
          'view:checkGuideDetails': { type: 'object', properties: {} },
          routingNumber,
          accountNumber,
          bankName: {
            ...financialInstitutionName,
            minLength: 1,
            pattern: '\\S',
          },
        },
      },
    },
  },
};
